import { TranslateService } from '@ngx-translate/core';
import { LimitedUserInfoDTO, ParkerRegistrationDTO, ParkerRegistrationType, ParkerRegistrationWithParkerInfoDTO } from 'src/app/base/models/models.swagger.generated';

export class ParkerRegistrationDetailsHelper {
  public static getRegisteredByText(registration: ParkerRegistrationDTO | ParkerRegistrationWithParkerInfoDTO, translate: TranslateService): string {
    if (!registration) {
      return null;
    }
    if (registration.type === ParkerRegistrationType.AutoScheduleEntry
      || registration.type === ParkerRegistrationType.AutoScheduleClose) {
      return translate.instant('i18n.domain.parker-registration.fields.agentTextForAutomaticEntry');
    }
    else {
      if (registration?.registeredByUserAgent) {
        return this.getAgentName(registration.registeredByUserAgent);
      }
      return registration?.registeredByZoneDeviceName;
    }
  }

  public static getAgentName(user: LimitedUserInfoDTO) {
    return `${user.firstname} ${user.lastname}`;
  }
}
